import baseAPI from '@/api/base';
import { EditLeaveRequest, GetLeaveRequest, RegisterLeaveRequest } from '@/dtos/leave_request.dto';
import {
  APPROVE_LEAVE_REQUEST_URL,
  CANCEL_LEAVE_REQUEST_URL,
  DELETE_LEAVE_REQUEST_URL,
  EDIT_LEAVE_REQUEST_URL,
  GET_LEAVE_REQUEST_STATS_URL,
  GET_LEAVE_REQUEST_URL,
  REGISTER_LEAVE_REQUEST_URL,
  REJECT_LEAVE_REQUEST_URL,
  TOGGLE_LEAVE_REQUEST_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class LeaveRequest {
  static getLeaveRequests = async (getLeaveRequest: GetLeaveRequest): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_LEAVE_REQUEST_URL, {
      params: getLeaveRequest,
    });
    console.log('response', response);
    return response;
  };

  static getLeaveStats = async (getLeaveRequest: GetLeaveRequest): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_LEAVE_REQUEST_STATS_URL, {
      params: getLeaveRequest,
    });
    console.log('response', response);
    return response;
  };

  static registerLeaveRequest = async (
    registerLeaveRequest: RegisterLeaveRequest
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_LEAVE_REQUEST_URL, {
      ...registerLeaveRequest,
    });
    console.log('response', response);
    return response;
  };

  static editLeaveRequest = async (editLeaveRequest: EditLeaveRequest): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_LEAVE_REQUEST_URL, {
      ...editLeaveRequest,
    });
    return response;
  };

  static approveLeaveRequest = async (editLeaveRequest: EditLeaveRequest): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(APPROVE_LEAVE_REQUEST_URL, {
      ...editLeaveRequest,
    });
    return response;
  };

  static rejectLeaveRequest = async (editLeaveRequest: EditLeaveRequest): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(REJECT_LEAVE_REQUEST_URL, {
      ...editLeaveRequest,
    });
    return response;
  };

  static cancelLeaveRequest = async (editLeaveRequest: EditLeaveRequest): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(CANCEL_LEAVE_REQUEST_URL, {
      ...editLeaveRequest,
    });
    return response;
  };

  static toggleLeaveRequestIsActive = async (
    editLeaveRequest: EditLeaveRequest
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_LEAVE_REQUEST_IS_ACTIVE_URL,
      {
        ...editLeaveRequest,
      }
    );
    return response;
  };

  static deleteLeaveRequest = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_LEAVE_REQUEST_URL}/${userId}`
    );
    return response;
  };
}

export default LeaveRequest;
